import React from 'react'
import { Blog } from './main-page/Blog'

export const Blogs = () => {
  return (
    <div>
        <Blog/>
        <Blog/>
        <Blog/>
        <Blog/>
    </div>
  )
}
